module.exports = __webpack_public_path__ + "img/style3.48d105bf.png";